webpackJsonp([116845206868004],{

/***/ 1422:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DeclineReasonInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-decline-reason-input-d7b6de3e6a63b5e57c39.js